import axios from '@/config/api.request'

export default {
  // 提交联系
  submit (data) {
    return axios.request({
      url: '/contact/submit',
      method: 'post',
      data: data
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/contact.js